export const ITPColorsLegend = {
    green: { min: 4.50, max: 5.00, label: 'green', color: '#00AF50', className: 'green-legend' },
    lime: { min: 4.00, max: 4.49, label: 'lime', color: '#92D14F', className: 'lime-legend' },
    yellow: { min:  3.30, max: 3.99, label: 'yellow', color: '#FFFF00', className: 'yellow-legend' },
    orange: { min: 2.80, max: 3.29, label: 'orange', color: '#FFC000', className: 'orange-legend' },
    red: { min: 1.00, max: 2.79, label: 'red', color: '#FF0000', className: 'red-legend' },
}